import styled from 'styled-components';

export const SliderWrapper = styled.div`
  width: 100%;
  position: 'relative';

  .rc-slider {
    position: absolute;
    top: 0;
    bottom: 0;
    height: auto;
    z-index: 4;
  }

  .rc-slider-handle {
    width:5px;
    height: 100%;
    background-color: #ffffff;
    border: none;
    border-radius: 0;
    margin-left: -2px;
  }

  .rc-slider-handle:active,
  .rc-slider-handle:focus {
    box-shadow: none;
    border: 0;
  }

  .rc-slider-rail,
  .rc-slider-track {
    display: none;
  }

  img {
    display: block;
    position: relative;
  }

  img:first-child {
    z-index: 2
  }

  img:last-child {
    position: absolute;
    top: 0;
    left: 0;
  }
`;



// WEBPACK FOOTER //
// ./src/components/digitalNomad/ImageComparisonSlider.style.js